export enum TtmTypes {
    announcements = 'announcements',
    barrier = 'barrier',
    beacons_cones = 'beacons_cones',
    closures = 'closures',
    detour_signs = 'detour_signs',
    route_signs = 'route_signs',
    fences = 'fences',
    other = 'other',
    parking_bans = 'parking_bans',
    permanent_signs = 'permanent_signs',
    rolling_equipment = 'rolling_equipment',
    signs = 'signs',
    mobile_light_poles = 'mobile_light_poles',
    andreas = 'andreas',
    temporary_vri = 'temporary_vri',
    traffic_controllers = 'traffic_controllers',
    deviations = 'deviations',
    tape_off = 'tape_off',
    temporary_road_markings = 'temporary_road_markings',
    shipping_measures = 'shipping_measures',
    shipping_measures_external = 'shipping_measures_external',
    matrix_signs = 'matrix_signs',
    rolling_messages = 'rolling_messages'
}
